(function () {
  if (!window.location.pathname.endsWith('/products/sovemaske')) return;

  const BUNDLE_VARIANTS = {
    1: '49612848038043',
    2: '49612706873499',
    3: '49612819169435',
  };

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('product-form form');
    if (!form) return;

    form.addEventListener(
      'submit',
      () => {
        const qtyInput = form.querySelector('[name="quantity"]');
        const qty = parseInt(qtyInput?.value || '1', 10);
        const bundleId = BUNDLE_VARIANTS[qty];
        if (bundleId) {
          form.querySelector('[name="id"]').value = bundleId;
          if (qtyInput) qtyInput.value = '1'; // always add 1x of the bundle
        }
      },
      true // capture phase — fires before product-form.js reads FormData
    );
  });
})();
